// Small helper to parse the legacy "PART x2, PART2" parts_used display string
// back into structured tokens so pickers can rehydrate existing maintenance logs.
const TOKEN_RE = /^\s*(.+?)\s*(?:[xX×*]\s*(\d+))?\s*$/;

export function parsePartsUsedString(str) {
  if (!str || !str.trim()) return [];
  const tokens = [];
  for (const raw of str.split(',')) {
    const trimmed = raw.trim();
    if (!trimmed) continue;
    const m = trimmed.match(TOKEN_RE);
    if (!m) {
      tokens.push({ part_number: trimmed, qty: 1 });
      continue;
    }
    const partNumber = m[1].trim();
    const qty = m[2] ? Math.max(1, parseInt(m[2], 10) || 1) : 1;
    tokens.push({ part_number: partNumber, qty });
  }
  return tokens;
}
